import { styled, css } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { Dots } from "../../hooks/useCarousel.js";
import { cssSpacing, surfaceColorMap } from "../../util/styles.js";
import type { BackgroundColor } from "../../types/theme.js";

export const StyledInfoGraphicConstrainer = styled.div<{
  $width?: "medium" | "full";
  $bg: BackgroundColor;
  $graphicsPosition?: "left" | "right";
}>`
  background-color: ${({ $bg }) => surfaceColorMap[$bg]};
  color: ${({ $bg }) => ($bg === "surface3" ? "#fff" : "var(--swatch2)")};
  svg path { fill: currentColor; stroke: currentColor; }
  position: relative;
  margin: 0 ${({ theme }) => theme.spacing.xs};
  max-width: 1100px;
  display: grid;
  grid-template-columns: 1fr;

  border-radius: ${(props) => props.theme.borderRadius};

  ${(props) =>
    props.$width === "full" &&
    css`
      max-width: 100%;
      margin: 0;
    `};

  @media (min-width: ${mobileBreakPointCSS}) {
    margin: 0 auto;
    grid-template-columns: 1fr 1fr;

    ${({ $graphicsPosition }) =>
      $graphicsPosition === "right" &&
      css`
        > :first-child {
          order: 2;
        }
        > :last-child {
          order: 1;
          justify-self: flex-end;
        }
      `}
  }
`;

export const StyledInfoGraphicRichText = styled.div<{ $hasGraphics: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${cssSpacing("l", "m")};

  > :nth-child(2) {
    margin-top: ${cssSpacing("l")};
  }

  h1,
  h2,
  h3 {
    margin-top: 0;
    margin-bottom: ${cssSpacing("s")};
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    max-width: 400px;
    padding: ${cssSpacing("xl")};
  }
`;

export const StyledInfoGraphicWrapper = styled.div<{
  $width?: "medium" | "full";
  $graphicsPosition?: "left" | "right";
}>`
  position: relative;

  .video-wrapper {
    height: 250px;
  }

  img,
  video {
    display: block;
    object-fit: cover;
    width: 100%;
    height: 250px;
    border-radius: ${(props) => props.theme.borderRadius}
      ${(props) => props.theme.borderRadius} 0 0;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    height: auto;

    .video-wrapper {
      height: 100%;
    }

    img,
    video {
      height: 100%;
      aspect-ratio: unset;
      border-radius: ${(props) =>
        props.$graphicsPosition === "right"
          ? `0 ${props.theme.borderRadius} ${props.theme.borderRadius} 0`
          : `${props.theme.borderRadius} 0 0 ${props.theme.borderRadius}`};
    }

    ${(props) =>
      props.$width === "full" &&
      css`
        img,
        video {
          height: 100%;
          aspect-ratio: 16 / 9;
        }
      `};
  }
`;

export const ArrowButton = styled.button<{ $position: "left" | "right" }>`
  position: absolute;
  top: 50%;
  ${({ $position }) => $position}: ${cssSpacing("m")};
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 2;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const StyledInfoGraphicDots = styled(Dots)`
  position: absolute;
  bottom: ${cssSpacing("s")};
  left: 50%;
  transform: translateX(-50%);
`;
